interface LoadingDisplayProps {
  message?: string;
  subtitle?: string;
}

export function LoadingDisplay({
  message = 'Loading...',
  subtitle,
}: LoadingDisplayProps) {
  return (
    <div className="flex items-center justify-center h-full bg-gray-50">
      <div className="text-center">
        <div className="inline-block w-6 h-6 border-2 border-gray-300 border-t-gray-600 rounded-full animate-spin mb-3" />
        <p className="text-sm text-gray-600">{message}</p>
        {subtitle && <p className="text-xs text-gray-400 mt-1">{subtitle}</p>}
      </div>
    </div>
  );
}
